// extracted by mini-css-extract-plugin
module.exports = {"description":"JumbotronWithLogos_description__11psF","logos":"JumbotronWithLogos_logos__3AFVh"};